import { palette } from '@livable/saas-react-components';
const MuiChip = {
  styleOverrides: {
    root: {
      borderRadius: '2px',
      padding: '2px 6px',
      fontSize: '15px',
      lineHeight: '20px',
      fontFamily: palette.fontFamilies.poppins,
      height: 'initial',
      whiteSpace: 'initial',
      '& + .MuiChip-root': {
        marginLeft: '10px'
      },
      '&:hover': {
        cursor: 'pointer'
      },
      '& .MuiChip-label': {
        overflow: 'initial',
        textOverflow: 'initial',
        whiteSpace: 'initial'
      }
    },
    label: {
      padding: '0'
    },
    icon: {
      margin: '0',
      width: '18px',
      height: '18px',
      marginRight: '5px'
    },
    sizeMedium: {
      padding: '5px 10px'
    },
    sizeLarge: {
      padding: '8px 10px'
    },
    inactive: {
      backgroundColor: palette.shades[300],
      color: palette.shades[700],
      '& .MuiSvgIcon-root': {
        width: '18px',
        height: '18px',
        marginRight: '5px'
      },
      '& path': {
        fill: palette.shades[600]
      }
    },
    info: {
      backgroundColor: palette.info.light,
      color: palette.info.dark,
      '& .MuiSvgIcon-root': {
        width: '18px',
        height: '18px',
        marginRight: '5px'
      },
      '& path': {
        fill: palette.info.main
      }
    },
    warning: {
      backgroundColor: palette.warning.light,
      color: palette.warning.dark,
      '& .MuiSvgIcon-root': {
        width: '18px',
        height: '18px',
        marginRight: '5px'
      },
      '& path': {
        fill: palette.warning.main
      }
    },
    success: {
      backgroundColor: palette.success.light,
      color: palette.success.dark,
      '& .MuiSvgIcon-root': {
        width: '18px',
        height: '18px',
        marginRight: '5px'
      },
      '& path': {
        fill: palette.success.main
      }
    },
    successBold: {
      backgroundColor: palette.success.main,
      color: palette.shades[100],
      '& .MuiSvgIcon-root': {
        width: '18px',
        height: '18px',
        marginRight: '5px'
      },
      '& path': {
        fill: palette.shadows[100]
      }
    },
    critical: {
      backgroundColor: palette.error.light,
      color: palette.error.dark,
      '& .MuiSvgIcon-root': {
        width: '18px',
        height: '18px',
        marginRight: '5px'
      },
      '& path': {
        fill: palette.error.main
      }
    },
    inactiveDropdown: {
      backgroundColor: 'transparent',
      padding: '0',
      color: palette.shades[700],
      '& .MuiChip-label': {
        backgroundColor: palette.shades[300],
        padding: '2px 6px',
        borderRadius: '0 2px 2px 0'
      },
      '& .MuiSvgIcon-root': {
        width: '24px',
        height: '24px',
        margin: '0',
        backgroundColor: palette.shades[300],
        borderRadius: '2px 0 0 2px',
        marginRight: '1px',
        '& path': {
          fill: palette.shades[700]
        }
      }
    },
    infoDropdown: {
      backgroundColor: 'transparent',
      padding: '0',
      color: palette.info.dark,
      '& .MuiChip-label': {
        backgroundColor: palette.info.light,
        padding: '2px 6px',
        borderRadius: '0 2px 2px 0'
      },
      '& .MuiSvgIcon-root': {
        width: '24px',
        height: '24px',
        margin: '0',
        backgroundColor: palette.info.light,
        borderRadius: '2px 0 0 2px',
        marginRight: '1px',
        '& path': {
          fill: palette.info.dark
        }
      }
    },
    warningDropdown: {
      backgroundColor: 'transparent',
      padding: '0',
      color: palette.warning.dark,
      '& .MuiChip-label': {
        backgroundColor: palette.warning.light,
        padding: '2px 6px',
        borderRadius: '0 2px 2px 0'
      },
      '& .MuiSvgIcon-root': {
        width: '24px',
        height: '24px',
        margin: '0',
        backgroundColor: palette.warning.light,
        borderRadius: '2px 0 0 2px',
        marginRight: '1px',
        '& path': {
          fill: palette.warning.dark
        }
      }
    },
    successDropdown: {
      backgroundColor: 'transparent',
      padding: '0',
      color: palette.success.dark,
      '& .MuiChip-label': {
        backgroundColor: palette.success.light,
        padding: '2px 6px',
        borderRadius: '0 2px 2px 0'
      },
      '& .MuiSvgIcon-root': {
        width: '24px',
        height: '24px',
        margin: '0',
        backgroundColor: palette.success.light,
        borderRadius: '2px 0 0 2px',
        marginRight: '1px',
        '& path': {
          fill: palette.success.dark
        }
      }
    },
    criticalDropdown: {
      backgroundColor: 'transparent',
      padding: '0',
      color: palette.error.dark,
      '& .MuiChip-label': {
        backgroundColor: palette.error.light,
        padding: '2px 6px',
        borderRadius: '0 2px 2px 0'
      },
      '& .MuiSvgIcon-root': {
        width: '24px',
        height: '24px',
        margin: '0',
        backgroundColor: palette.error.light,
        borderRadius: '2px 0 0 2px',
        marginRight: '1px',
        '& path': {
          fill: palette.error.dark
        }
      }
    },
    inactiveIcon: {
      backgroundColor: palette.shades[300],
      padding: '3px',
      '& .MuiSvgIcon-root': {
        margin: '0',
        width: '18px',
        height: '18px'
      },
      '&.MuiChip-sizeBig': {
        padding: '6px',
        '& .MuiSvgIcon-root': {
          width: '24px',
          height: '24px'
        }
      },
      '& path': {
        fill: palette.shades[600]
      }
    },
    infoIcon: {
      backgroundColor: palette.info.light,
      padding: '3px',
      '& .MuiSvgIcon-root': {
        margin: '0',
        width: '18px',
        height: '18px'
      },
      '& path': {
        fill: palette.info.main
      }
    },
    warningIcon: {
      backgroundColor: palette.warning.light,
      padding: '3px',
      '& .MuiSvgIcon-root': {
        margin: '0',
        width: '18px',
        height: '18px'
      },
      '& path': {
        fill: palette.warning.main
      }
    },
    successIcon: {
      backgroundColor: palette.success.light,
      padding: '3px',
      '& .MuiSvgIcon-root': {
        margin: '0',
        width: '18px',
        height: '18px'
      },
      '& path': {
        fill: palette.success.main
      }
    },
    criticalIcon: {
      backgroundColor: palette.error.light,
      padding: '3px',
      '& .MuiSvgIcon-root': {
        margin: '0',
        width: '18px',
        height: '18px'
      },
      '& path': {
        fill: palette.error.main
      }
    },
    greyIcon: {
      backgroundColor: palette.shades[300],
      padding: '3px',
      '& .MuiSvgIcon-root': {
        margin: '0',
        width: '18px',
        height: '18px'
      },
      '& path': {
        fill: palette.shades[700]
      }
    },
    inactivePlain: {
      padding: '0',
      backgroundColor: 'transparent',
      color: palette.shades[800],
      '& .MuiSvgIcon-root': {
        width: '24px',
        height: '24px',
        marginRight: '5px'
      },
      '& path': {
        fill: palette.shades[600]
      }
    },
    infoPlain: {
      padding: '0',
      backgroundColor: 'transparent',
      color: palette.info.dark,
      '& .MuiSvgIcon-root': {
        width: '24px',
        height: '24px',
        marginRight: '5px'
      },
      '& path': {
        fill: palette.info.main
      }
    },
    warningPlain: {
      padding: '0',
      backgroundColor: 'transparent',
      color: palette.warning.dark,
      '& .MuiSvgIcon-root': {
        width: '24px',
        height: '24px',
        marginRight: '5px'
      },
      '& path': {
        fill: palette.warning.main
      }
    },
    successPlain: {
      padding: '0',
      backgroundColor: 'transparent',
      color: palette.success.dark,
      '& .MuiSvgIcon-root': {
        width: '24px',
        height: '24px',
        marginRight: '5px'
      },
      '& path': {
        fill: palette.success.main
      }
    },
    criticalPlain: {
      padding: '0',
      backgroundColor: 'transparent',
      color: palette.error.dark,
      '& .MuiSvgIcon-root': {
        width: '24px',
        height: '24px',
        marginRight: '5px'
      },
      '& path': {
        fill: palette.error.main
      }
    },
    button: {
      backgroundColor: palette.shades[200],
      color: palette.shades[800],
      '&:hover': {
        backgroundColor: palette.shades[300],
        boxShadow: 'none'
      }
    }
  },
  variants: [{
    props: {
      variant: 'portal'
    },
    style: {
      backgroundColor: palette.shades[200],
      borderRadius: '2px',
      padding: '6px',
      width: '36px',
      height: '36px',
      border: '1px solid transparent',
      transition: "all ".concat(palette.transitions.short),
      '&:hover': {
        backgroundColor: palette.shades[300]
      },
      '&:active': {
        boxShadow: 'none'
      },
      '&.MuiChip-colorSuccess': {
        '& path': {
          fill: palette.success.main
        }
      },
      '&.MuiChip-colorInfo': {
        '& path': {
          fill: palette.info.main
        }
      },
      '&.MuiChip-colorWarning': {
        '& path': {
          fill: palette.warning.main
        }
      },
      '&.MuiChip-colorError': {
        '& path': {
          fill: palette.error.main
        }
      },
      '&.MuiChip-colorDefault': {
        backgroundColor: palette.shades[200],
        borderColor: palette.shades[300],
        '& path': {
          fill: palette.shades[400]
        },
        '&:hover': {
          cursor: 'default'
        }
      }
    }
  }]
};
export default MuiChip;